import { Address } from '@shared/classes/Address';

export function getAddressString(address: Address): string {
  if (!address) {
    return '';
  }

  return `${address.city.zipCode} ${address.city.name}, ${address.street}`;
}
